// Use this utility to combine URL path fragments without worrying about leading or trailing slashes.
const combinePaths = (fragments: string[]): string =>
  fragments
    .map((f, i) => {
      if (i === 0) {
        return f.replace(/\/$/, '');
      }
      if (i === fragments.length - 1) {
        return f.replace(/^\//, '');
      }
      return f.replace(/^\/|\/$/g, '');
    })
    .join('/');

export default combinePaths;
